<template>
  <div id="prop-tags" class="prop-tags">
    <h2>Nearby locations</h2>
    <ul class="tags">
      <li class="tag" v-for="tagItem in tagItems" :key="tagItem.id">
        <a class="link"
           :title="tagItem.link_text"
           :aria-label="tagItem.link_text"
           :href="tagItem.path+'-holiday-cottages'">
          {{tagItem.link_text}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    tagItems: Array
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-tags {
  margin: 0 1.25rem 1.25rem;
  border-bottom: 1px solid #D9D9D9;

  h2 {
    font-size: 1.25rem;
    line-height: 1.25rem;
    margin: 1.25rem 0;
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    margin: 1.25rem 0;
    row-gap: .625rem;
    column-gap: .625rem;

    @media #{$desktop} {
      padding: 0;
    }
  }

  .tag {
    border-radius: .3125rem;
    background-color: $col_xlgrey;
    min-height: auto;
    list-style: none;
    transition: .3s;

    @media (hover: hover) {
      &:hover {
        background-color: $col_primary;
      }
    }
  }

  .link {
    color: #424242;
    font-size: .875rem;
    transition: .3s;
    line-height: 1.2;
    display: block;
    padding: .625rem;
    text-decoration: none;
    text-align: center;

    @media (hover: hover) {
      &:hover {
        color: $col_white;
      }
    }
  }
  @media #{$desktop} {
    margin: 0 0 1.25rem;

    h2 {
      font-size: 1.5rem;
      line-height: 1.813rem;
    }
  }
}
</style>